import { render } from "./RegularMovingByGeoTemplateTableElement.vue?vue&type=template&id=1cc1c72a&scoped=true"
import script from "./RegularMovingByGeoTemplateTableElement.vue?vue&type=script&lang=js"
export * from "./RegularMovingByGeoTemplateTableElement.vue?vue&type=script&lang=js"

import "./RegularMovingByGeoTemplateTableElement.vue?vue&type=style&index=0&id=1cc1c72a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc1c72a"]])

export default __exports__